import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { Links_Customer, Links_Machine, sortFn } from "../../Utils.js";
import { int32ToString, createObj, uncurry2, equals } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { Machine_getNameOrCode, DateOnly_now, strIContains, ServiceStatus } from "../../Shared/Shared.js";
import { isNullOrWhiteSpace } from "../../fable_modules/fable-library-js.4.24.0/String.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Service_$reflection } from "../../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { some, unwrap, map, defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { onPageChange, listLoadingIndicator, headerSortCell } from "../../ViewHelpers.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TablePagination, Link, TableBody, TableHead, TableRow, Table, TableContainer, Checkbox, FormControlLabel, Typography, TableCell } from "@mui/material";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Components_Searchbar_25F45B5E } from "../../Components/Searchbar.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { parse } from "../../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { compare } from "../../fable_modules/fable-library-js.4.24.0/Date.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Activities_StatusChip_2E7B7895 } from "../../Activities/StatusChip.js";
import { Activities_SeverityChip_2E7B7895 } from "../../Activities/SeverityChip.js";
import { toDateOnlyStr } from "../../Locale.js";

export function Dashboard_ActivitiesTable_Z37302880(dashboard_ActivitiesTable_Z37302880InputProps) {
    const customerId = dashboard_ActivitiesTable_Z37302880InputProps.customerId;
    const groupId = dashboard_ActivitiesTable_Z37302880InputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState([]);
    const patternInput_2 = reactApi.useState(false);
    const showClosed = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(true);
    const asc = patternInput_4[0];
    const patternInput_5 = reactApi.useState("PlannedDate");
    const sortKey = patternInput_5[0];
    const patternInput_6 = reactApi.useState(0);
    const setPage = patternInput_6[1];
    const page = patternInput_6[0] | 0;
    const patternInput_7 = reactApi.useState(5);
    const rowsPerPage = patternInput_7[0] | 0;
    const rowsPerPageOptions = new Int32Array([5, 10, 15, 20]);
    const filtered = sortFn(asc, sortKey)(patternInput_1[0].filter((a) => {
        let a_1, b;
        if ((a_1 = showClosed, (b = !equals(a.Status, new ServiceStatus(2, [])), (a_1 ? true : b) && !(a_1 && b)))) {
            const contains = (str) => strIContains(patternInput_3[0], str);
            const machineName = isNullOrWhiteSpace(a.MachineName) ? contains(a.MachineCode) : contains(a.MachineName);
            if (contains(a.VismaOrder) ? true : machineName) {
                return true;
            }
            else {
                return contains(a.Customer);
            }
        }
        else {
            return false;
        }
    }));
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((filtered.length < nextTakeCount) ? (filtered.length - rowsToSkip) : rowsPerPage);
    const dependencies = [groupId, customerId];
    reactApi.useEffect(() => {
        let properties_2;
        setLoading(true);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Service_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(`/api/customer/${customerId}/activities`, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Service_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 1) {
                console.error(some("Could not fetch activities"), res.fields[0]);
            }
            else {
                patternInput_1[1](res.fields[0]);
            }
            setLoading(false);
        });
    }, dependencies);
    const th$0027 = (key_1, label) => headerSortCell(sortKey, asc, (key) => {
        patternInput_4[1](!asc);
        patternInput_5[1](key);
    }, key_1, label);
    const cell = (child) => MuiHelpers_createElement(TableCell, [["variant", "body"], ["children", child]]);
    const xs_7 = toList(delay(() => {
        let elems_2, elems, elems_1;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
        }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
            flexGrow: 1,
        }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("OverviewDashboard.ActivityPlan")]])], ["children", reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("Closed")], ["checked", showClosed], ["onChange", (e) => {
            patternInput_2[1](e.target.checked);
        }], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"]])]]), createElement("div", createObj(ofArray([["style", {
            flexBasis: 320 + "px",
        }], (elems_1 = [createElement(Components_Searchbar_25F45B5E, {
            placeholder: ctx.Locale.t("Search"),
            onChange: (ev) => {
                patternInput_3[1](ev.target.value);
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elements_5, elements_4, children, elems_3, elements_3;
            return patternInput[0] ? singleton(listLoadingIndicator(30)) : append(singleton(MuiHelpers_createElement(TableContainer, [(elements_5 = [MuiHelpers_createElement(Table, [(elements_4 = [(children = singleton_1(MuiHelpers_createElement(TableRow, [(elems_3 = [MuiHelpers_createElement(TableCell, [["variant", "head"], ["size", "small"], ["children", ctx.Locale.t("Ticket.Status.Status")]]), th$0027("Severity", "Severity"), th$0027("MachineName", ctx.Locale.t("Machine")), th$0027("Customer", ctx.Locale.t("Customer.Customer")), th$0027("PlannedDate", ctx.Locale.t("Services.PlannedDate"))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children))]])), MuiHelpers_createElement(TableBody, [(elements_3 = toList(delay(() => {
                let elems_6, elements_1;
                return (filtered.length === 0) ? singleton(MuiHelpers_createElement(TableRow, [(elems_6 = [MuiHelpers_createElement(TableCell, [["colSpan", 6], ["align", "center"], ["size", "small"], (elements_1 = [createElement("i", {
                    children: [ctx.Locale.t("OverviewDashboard.NoPlannedActivities")],
                })], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_6))])])) : singleton(map_1((st) => {
                    let elements_2;
                    const now = DateOnly_now();
                    const plannedDateOnly = parse(st.PlannedDate);
                    const pastDueDate = (compare(plannedDateOnly, now) < 0) && !equals(st.Status, new ServiceStatus(2, []));
                    const machineName_1 = Machine_getNameOrCode({
                        code: st.MachineCode,
                        name: st.MachineName,
                    });
                    return MuiHelpers_createElement(TableRow, [["style", {
                        cursor: "pointer",
                    }], ["onClick", (ev_1) => {
                        ev_1.preventDefault();
                        RouterModule_nav(ofArray(["group", int32ToString(groupId), "customer", int32ToString(st.CustomerId), "machine", int32ToString(st.MachineId), "service", int32ToString(st.Id)]), 1, 1);
                    }], ["hover", true], (elements_2 = [cell(createElement("div", {
                        style: {
                            display: "flex",
                        },
                        children: createElement(Activities_StatusChip_2E7B7895, st),
                    })), cell(createElement("div", {
                        style: {
                            display: "flex",
                        },
                        children: createElement(Activities_SeverityChip_2E7B7895, st),
                    })), cell(MuiHelpers_createElement(Link, [["href", Links_Machine(groupId, st.CustomerId, st.MachineId)], ["noWrap", true], ["children", machineName_1]])), cell(MuiHelpers_createElement(Link, [["href", Links_Customer(groupId, st.CustomerId)], ["noWrap", true], ["children", st.Customer]])), cell(createElement("span", {
                        style: createObj(toList(delay(() => (pastDueDate ? singleton(["color", "#e85555"]) : empty_1())))),
                        children: toDateOnlyStr(ctx.DateFnsLocale, plannedDateOnly),
                    }))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
                }, filtered.slice(rowsToSkip, (rowsToSkip + rowsToTake) + 1)));
            })), ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elements_5))])])), delay(() => singleton(MuiHelpers_createElement(TablePagination, [["component", "div"], ["count", filtered.length], ["page", page], ["rowsPerPage", rowsPerPage], ["rowsPerPageOptions", Array.from(rowsPerPageOptions)], ["onPageChange", ((arg10$0040, newPage) => {
                onPageChange(setPage, arg10$0040, newPage);
            })], ["onRowsPerPageChange", (ev_2) => {
                const newRowsPerPage = ev_2.target.value | 0;
                setPage(0);
                patternInput_7[1](newRowsPerPage);
            }]]))));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_7);
}

